/*
 * Moves the Kiwi Sizing "size chart" link next to the size label of the variant picker.
 * The variant picker renders an empty [data-size-chart-slot] beside the first non-color option;
 * Kiwi injects its link (.ks-chart-container) elsewhere (usually above the add to cart button).
 */
(function () {
  if (window.__sizeChartSlotInit) return;
  window.__sizeChartSlotInit = true;

  var chart = null;
  var scheduled = false;

  function findChart() {
    var list = document.querySelectorAll('.ks-chart-container');
    for (var i = list.length - 1; i >= 0; i--) {
      if (!list[i].closest('.kiwi-sizing-modal-hidden-container, .kiwi-sizing-modal')) return list[i];
    }
    return null;
  }

  function place() {
    scheduled = false;
    var slot = document.querySelector('variant-picker [data-size-chart-slot]');
    if (!slot) return;

    var found = findChart();
    if (found) chart = found;
    if (!chart) return;

    if (chart.parentNode !== slot) slot.appendChild(chart);

    // Drop stale duplicates that Kiwi may have left in the slot after re-rendering its link
    var children = slot.querySelectorAll('.ks-chart-container');
    for (var i = 0; i < children.length; i++) {
      if (children[i] !== chart) children[i].parentNode.removeChild(children[i]);
    }
  }

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(place);
  }

  new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
  schedule();
})();
